import { render, staticRenderFns } from "./AttendanceUpdater.vue?vue&type=template&id=425e09b9"
import script from "./AttendanceUpdater.vue?vue&type=script&lang=js"
export * from "./AttendanceUpdater.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports